import RejectClaimDialogContainer from "./rejectClaimDialog.container";

export default RejectClaimDialogContainer;
